function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.56 21a1 1 0 01-.46-.11L12 18.22l-5.1 2.67a1 1 0 01-1.45-1.06l1-5.63-4.12-4a1 1 0 01-.25-1 1 1 0 01.81-.68l5.7-.83 2.51-5.13a1 1 0 011.8 0l2.54 5.12 5.7.83a1 1 0 01.81.68 1 1 0 01-.25 1l-4.12 4 1 5.63a1 1 0 01-.4 1 1 1 0 01-.62.18z",
  "data-name": "star"
}));

function SvgIconStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9InN0YXIiPjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTIgMTIpIiBvcGFjaXR5PSIwIi8+PHBhdGggZD0iTTE3LjU2IDIxYTEgMSAwIDAgMS0uNDYtLjExTDEyIDE4LjIybC01LjEgMi42N2ExIDEgMCAwIDEtMS40NS0xLjA2bDEtNS42My00LjEyLTRhMSAxIDAgMCAxLS4yNS0xIDEgMSAwIDAgMSAuODEtLjY4bDUuNy0uODMgMi41MS01LjEzYTEgMSAwIDAgMSAxLjggMGwyLjU0IDUuMTIgNS43LjgzYTEgMSAwIDAgMSAuODEuNjggMSAxIDAgMCAxLS4yNSAxbC00LjEyIDQgMSA1LjYzYTEgMSAwIDAgMS0uNCAxIDEgMSAwIDAgMS0uNjIuMTh6Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgIconStarFilled as ReactComponent };